import { render, staticRenderFns } from "./Chartfour.vue?vue&type=template&id=794d2fda"
import script from "./Chartfour.vue?vue&type=script&lang=js"
export * from "./Chartfour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports